'use strict';

var dateFns = require('date-fns');

function parseToAvailableType(data) {
  if (typeof data === "string") {
    return dateFns.parseISO(data);
  } else {
    return data;
  }
}
const isWithinCriteriaMinutes = ({
  leftDate,
  rightDate,
  criteriaMinutes = 1
}) => Math.abs(
  dateFns.differenceInMinutes(
    parseToAvailableType(leftDate),
    parseToAvailableType(rightDate)
  )
) <= criteriaMinutes;

module.exports = isWithinCriteriaMinutes;
//# sourceMappingURL=isWithinCriteriaMinutes.cjs.map
